export function NotImplemented(functionName: string = '') {
  if (process.env.NODE_ENV === 'development')
    alert('Function not Implemented' + (functionName ? (': ' + functionName) : ''))
}